<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-body" v-loading="loading">
                <el-alert v-if="missings.length > 0"
                  title="แจ้งเตือน"
                  type="error"
                  show-icon
                  :closable="false"
                  >
                  พบรายการส่งเสริมการขายที่ยังให้บริการอยู่และไม่ได้นำส่งในรอบปัจจุบันทั้งหมด {{missings.length}} รายการ
                  <div v-for="(item,index) in missings" :key="index">{{1+index+'. รายการส่งเสริมการขายรหัส '+item}}</div> 
                </el-alert><br>
                <el-alert
                  :title="'จำนวนและสัดส่วนร้อยละ โดยที่สัดส่วนโปรวินาทีจะต้องไม่ต่ำกว่า '+proportion.proportion_second+'%'"
                  :type="alert_status.min_sec"
                  show-icon
                  :closable="false">
                  โปรนาทีจำนวน {{ total_min_sec.minute }} รายการ <br>
                  โปรวินาทีจำนวน {{ total_min_sec.second }} รายการ <br>
                  อัตราส่วนร้อยละโปรนาที คิดเป็น {{ total_min_sec.minute_percent >= 0 ? total_min_sec.minute_percent : 0 }} % <br>
                  อัตราส่วนร้อยละโปรวินาที คิดเป็น {{ total_min_sec.second_percent >= 0 ? total_min_sec.second_percent : 0 }} % <br>
                </el-alert><br>
                <el-alert
                  title="อัตราค่าบริการเฉลี่ยแยกตามประเภทบริการ เปรียบเทียบกับอัตรากำกับดูแล"
                  :type="alert_status.regulate"
                  show-icon
                  :closable="false">
                  <table>
                    <tr>
                      <td></td>
                      <td>ค่าบริการเฉลี่ย</td>
                      <td>อัตราที่กำกับ</td>
                      <td>ผ่านเกณฑ์</td>
                    </tr>
                    <tr v-for="(item,service) in averages" :key="service">
                      <td>{{service}}</td>
                      <td>{{item}}</td>
                      <td>{{ regulates[service].value }}</td>
                      <td>{{ regulates[service].status }}</td>
                    </tr>
                  </table>
                </el-alert><br>
                <el-card>
                  <h4>ตารางแสดงข้อมูลการนำเข้าไฟล์ข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</h4>
                    <data-tables
                    :data="PreviewRows"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column 
                      sortable 
                      v-for="(col,index) in schema_en" 
                      :key="index"  
                      :prop="col" 
                      :label="schema_th[index]" 
                      :width="schema_th[index].length*10" 
                      show-overflow-tooltip height="250"
                      >
                    </el-table-column >
                  </data-tables>
                </el-card>
                <br>
                <div class="wrapper_confirm_promotion box-body" >
                  <b v-if="!errors.length">ยืนยันการนำเข้าข้อมูลรายการส่งเสริมการขายประจำเดือน{{ month_title }} </b>
                  <div v-if="show_err">
                    <div style="margin-bottom: 30px; margin-top: 30px">
                      <b>ไม่สามารถนำเข้าข้อมูลรายการส่งเสริมการขายได้เนื่องจากพบข้อมูลผิดพลาดทั้งหมด {{errors.length}} รายการ</b>
                      <el-button
                        :disabled="pending"
                        @click="exporting()"
                        class="pull-right"
                        type="success"
                        size="small"
                      >
                        Export
                      </el-button>
                    </div>
                    <el-table
                      :data="errors"
                      :row-class-name="tableRowClassName"
                      :header-row-style="headerStyle">
                      <el-table-column
                        prop="row"
                        label="แถว"
                        width="75">
                      </el-table-column>
                      <el-table-column
                        prop="row"
                        label="รหัสรายการส่งเสริมการขาย"
                        width="150">
                        <template slot-scope="scope">
                          {{ PreviewRows[scope.row.row-9].promotion_code || '' }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="col"
                        label="ชื่อคอลัมน์">
                        <template slot-scope="scope">
                          {{ schema_th[scope.row.col] }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="col"
                        label="ข้อมูล">
                        <template slot-scope="scope">
                          {{ PreviewRows[scope.row.row-9][schema_en[scope.row.col]] }}
                        </template>
                      </el-table-column>
                      <el-table-column 
                        prop="type"
                        label="คำอธิบาย">
                        <template slot-scope="scope">
                          <template v-if="scope.row.type == 'diffs'">
                            {{ "พบการเปลี่ยนแปลงข้อมูล" }}<br>
                            {{ "ข้อมูลใหม่ : "+(scope.row.new || "") }}<br>
                            {{ "ข้อมูลเดิม : "+(scope.row.old || "") }}
                          </template>
                          <template v-else>
                            {{ scope.row.detail }}
                          </template>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <br><br>
                  <el-button
                    size="small"
                    type="primary"
                    @click="cancelUpload"
                  >ย้อนกลับ</el-button>
                  <el-button
                    size="small"
                    type="success"
                    @click="submitUpload"
                    :disabled="(!!errors.length) || sending"
                  >ตกลง</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
  .el-label{
    white-space: nowrap
  }
  .el-table .warning-row {
    background: #ffe3ba;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row {
    background: #c1e0ff;
  }
  .el-table .danger-row {
    background: #fdbdbd;
  }
</style>
<script>
import { mapState, mapActions } from "vuex";
import { parse } from "json2csv";
export default {
  data() {
    return {
      selectDate: "",
      type: "",
      tableProps: {
        border: false,
        stripe: true,
        defaultSort: {
          prop: 'flow_no',
          order: 'descending'
        }
      },
      sending : false,
      pending : false,
      show_err : false,
      tableRowClassName : function({row, rowIndex}) {
        var color_class = {
          diffs : 'info-row',
          required : 'danger-row'
        }
        return color_class[row.type] ? color_class[row.type] : ''
      },
      headerStyle : function({row, rowIndex}){
        return 'border: 1px solid black;'
      },
      exporting : async function(){
        this.pending = true
        try {
          const err_log = await this.$store.dispatch('Promotion/create_export_data')
          const csv = parse(err_log);
          var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(csv)
          var link = document.createElement('a')
          document.body.appendChild(link)
          link.setAttribute('href', csvContent)
          link.setAttribute('download', `upload_error_log.xls`)
          link.click()
          document.body.removeChild(link)
          setTimeout(() => {
            this.pending = false
          }, 1000);
        } catch (err) {
          console.error(err);
        }
      }
    };
  },
  computed: {
    ...mapState({
      PreviewRows: store => store.Promotion.PreviewRows,
      loading : store => store.Promotion.loading,
      schema_th : store => store.Promotion.schema_th,
      schema_en : store => store.Promotion.schema_en,
      errors : store => store.Promotion.errors,
      month_title : store => store.Promotion.month_title,
      regulates : store => store.Promotion.regulates,
      averages : store => store.Promotion.averages,
      proportion : store => store.Promotion.proportion_min_sec,
      total_min_sec : store => store.Promotion.total_min_sec,
      alert_status : store => store.Promotion.alert_status,
      missings : store => store.Promotion.missings
    })
  },
  watch: {
    errors : {
      handler : function(reload){
        this.show_err = !!this.errors.length
      }
    }
  },
  methods: {
    ...mapActions({
      submitUploadMonthly : 'Promotion/submitUploadMonthly'
    }),
    submitUpload() {
      this.sending = true
      this.submitUploadMonthly()
    },
    cancelUpload() {
        this.$router.push({ name: "Add_uploadsave" });
      }
    },
    tableRowClassName({row, rowIndex}) {
      var color_class = {
        diffs : 'info-row',
        required : 'danger-row'
      }
      return color_class[row.type] ? color_class[row.type] : ''
    }
};
</script>
